import React from "react";
import Breadcrumb from "../navigation/Breadcrumb"

const ForumHeaderSection = ({forum, breadcrumbPages}) => {
    return (
        <div className="w-vw bg-purple-900 py-3 overflow-x-auto md:overflow-x-hidden rounded-none md:rounded-t-md  shrink-0">
            <div className="mx-auto flex flex-col justify-center max-w-7xl sm:px-6 lg:px-8" >
                <div className="p">
                    <Breadcrumb 
                        id={'post-header-crumps'} 
                        pages={breadcrumbPages} 
                        textColor="text-purple-200" 
                        hoverColor="text-purple-dark"
                    />
                </div>
            </div>
        </div>
    );
};



export default ForumHeaderSection;